import { useLocation } from 'react-router-dom';

const useSearchParams = <T extends Record<string, string>>(): T => {
  const { search } = useLocation();
  return search
    .replace('?', '')
    .split('&')
    .reduce((acc, cur) => {
      const split = cur.split('=');
      const key = split[0];
      const value = split[1];

      return key ? { ...acc, [key]: value } : acc;
    }, {}) as T;
};

export default useSearchParams;
